// extracted by mini-css-extract-plugin
export default {"notifications":"notifications_notifications__Etc40"};